import { render } from "./RemoveAddonsModal.vue?vue&type=template&id=44759fba&ts=true"
import script from "./RemoveAddonsModal.vue?vue&type=script&lang=ts"
export * from "./RemoveAddonsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__